<template>
  <div class="-used" title="In Use"></div>
</template>

<script>
export default {
  name: 'AssetUsed',
};
</script>

<style lang="scss" scoped>
.-used {
  width: 12px;
  height: 12px;
  background-color: $color-secondary;
  border: 1px solid rgb(255, 255, 255);
  border-radius: 50%;
  box-shadow: 1px 1px 4px 0 rgba(0, 0, 0, 0.5);
}
</style>
